/**
 * Type de saisie autorisée dans un champs texte
 */
export enum EditFormat {
  STR = 0,
  INT = 1,
  DEC = 2,
  EMAIL = 3,
}
